(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Canopus.sel('.template-customers-addresses', {

	created: function created() {
		var _this = this;

		this.on('click', '#add-address', function (e) {
			e.preventDefault();
			$('html').addClass('show-new-address-box');
			_this.scroll();
		});

		this.on('click', '#box-for-new-address .back-button', function (e) {
			e.preventDefault();
			$('html').removeClass('show-new-address-box');
			_this.notify('/updateHeight');
			_this.scroll();
		});
	},

	scroll: function scroll() {
		document.body.scrollTop = document.documentElement.scrollTop = $('.mypage-grid').offset().top - $('.global-header').height();
	}
});

Canopus.sel('.customers-addresses', {

	created: function created() {
		var _this2 = this;

		this.items = $(this.el).find('.customers-address .data');

		Polaris.util.onResize(function () {
			return _this2.update();
		});

		this.observe('/updateHeight', function () {
			return _this2.update();
		});
	},

	update: function update() {

		var maxHeight = this.items.css({ height: '' }).toArray().reduce(function (height, el) {
			return Math.max(height, el.clientHeight);
		}, 0);

		this.items.css({ height: maxHeight });
	}
});

Canopus.sel('.address-input-wrapper', {

	created: function created() {
		var _this3 = this;

		this.on('change', '.country-selector select', function (event) {
			_this3.countryChanged(event.target.value);
		});

		this.countryChanged($('.country-selector select').val());
	},

	countryChanged: function countryChanged(country) {

		if (country !== '---') {
			$(this.el).attr('country', country);
		}
	}
});

Canopus.sel('.customers-address', {

	created: function created() {
		var _this4 = this;

		var addressID = this.attr['address-id'];

		this.on('click', '.button-edit', function (e) {
			e.preventDefault();
			$(_this4.el).addClass('edit-mode');
			_this4.scroll();
		});

		this.on('click', '.back-button', function (e) {
			e.preventDefault();
			$(_this4.el).removeClass('edit-mode');
			_this4.notify('/updateHeight');
			_this4.scroll();
		});

		this.on('click', '.button-delete', function (e) {
			e.preventDefault();
			Shopify.CustomerAddress.destroy(addressID, 'お届け先を削除しますか？');
		});
	},

	scroll: function scroll() {
		document.body.scrollTop = document.documentElement.scrollTop = $(this.el).offset().top - $('.global-header').height();
	}
});

},{}],2:[function(require,module,exports){
"use strict";

Canopus.sel('.template-customers-login', {

	created: function created() {

		this.on('click', '#show-recover-password', function (e) {
			e.preventDefault();
			$('html').addClass('show-recover-box');
		});

		this.on('click', '#hide-recover-password', function (e) {
			e.preventDefault();
			$('html').removeClass('show-recover-box');
		});
	}
});

},{}],3:[function(require,module,exports){
'use strict';

Canopus.sel('.template-cart form', {
  created: function created() {
    var _this = this;

    this.cartItems = $(this.el).find('.cart-item');

    this.on('change', function () {
      $('html').addClass('loading');

      $(_this.el).find('input[type=submit]').attr('disabled', 'disabled');

      var updates = $(_this.el).find('.cart-item select.updates').toArray().map(function (el, i) {
        return el.value;
      });

      jQuery.ajax({
        url: '/cart/update.js',
        type: 'post',
        data: { updates: updates },
        dataType: 'json'
      }).done(function (result) {
        $('.global-header .cart-button .text').text('' + result.item_count);

        $('.page-title .count').text('' + result.item_count);

        $(_this.el).find('.cart-item').each(function (i, el) {
          $(el).find('.price').text('\xA5' + _this.pasrsePrice(result.items[i].line_price * 1.1));
        });

        $(_this.el).find('.cart-count').text('' + result.item_count);
        $(_this.el).find('.cart-subtotal').text('\xA5' + _this.pasrsePrice(result.total_price * 1.1));
        $(_this.el).find('.cart-tax').text('\xA5' + _this.pasrsePrice(result.total_price * 0.1));
        $(_this.el).find('.cart-total').text('\xA5' + _this.pasrsePrice(result.total_price * 1.1));

        $(_this.el).find('input[type=submit]').removeAttr('disabled');

        result.items.forEach(function (item, i) {
          if (_this.cartItems.eq(i).attr('data-inventory-policy') == 'continue') {
            if (item.quantity > _this.cartItems.eq(i).attr('data-inventory-quantity')) {
              _this.cartItems.eq(i).addClass('order-item');
            } else {
              _this.cartItems.eq(i).removeClass('order-item');
            }
          }
        });

        $('html').removeClass('loading');
      });
    });
  },

  pasrsePrice: function pasrsePrice(price) {
    return String(price / 100 | 0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  }
});

},{}],4:[function(require,module,exports){
"use strict";

Canopus.sel('.template-collection .hero-view', {

	created: function created() {
		var _this = this;

		this.observe('/loaded', function () {
			$(_this.el).find('.image-wrapper div').addClass('show');
			$(_this.el).find('.text-wrapper .hero-title').addClass('show');
			$(_this.el).find('.text-wrapper .hero-text-en').addClass('show');
			$(_this.el).find('.text-wrapper .hero-text-ja').addClass('show');
		});
	}
});

},{}],5:[function(require,module,exports){
'use strict';

Canopus.sel('.product-list-item', {
  created: function created() {
    var _this = this;

    var $el = $(this.el);
    this.item = $el.find('.product-item');
    this.img = $el.find('.product-image img');

    this.scrollID = Polaris.util.onScroll(function (t, b) {
      if ($el.hasClass('none')) return;

      var offset = _this.item.offset().top;
      var height = _this.item.height();

      var rate = Polaris.util.visibleAreaRate(offset, height, t, b);

      if (rate > 0.5) {
        _this.show();
      }
    });
  },

  destroy: function destroy() {
    Polaris.util.offScroll(this.scrollID);
  },

  show: function show() {
    this.img.attr('src', this.img.attr('data-src'));
    this.item.addClass('show');
    Polaris.util.offScroll(this.scrollID);
  }
});

},{}],6:[function(require,module,exports){
"use strict";

var _config = require('../../core/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Canopus.sel('.template-page-contact', {

	created: function created() {

		var param = Polaris.util.parseParam();

		if ('pid' in param) {

			jQuery.ajax({
				url: _config2.default.API_URL + '/v1/products/get',
				type: 'GET',
				dataType: 'json',
				data: {
					product_id: param.pid
				}
			}).done(function (json) {
				$('#input-title').val(json.title_ja);
				$('#input-product-id').val(json.id);

				if ($('#contact-body').val() === '') {
					$('#contact-body').val('\u5546\u54C1\u540D\uFF1A' + json.title_ja);
				}
			});
		} else {
			$('#input-title').remove();
			$('#input-product-id').remove();
		}
	}
});

},{"../../core/config":23}],7:[function(require,module,exports){
"use strict";

Canopus.sel('.about-opener', {

	created: function created() {
		var _this = this;

		this.wrapper = $(this.el).find('.about-opener-wrapper');

		this.on('click', '.about-opener-title', function () {

			$(_this.el).toggleClass('opened');

			if ($(_this.el).hasClass('opened')) {
				_this.openBox();
			} else {
				_this.closeBox();
			}
		});
	},

	openBox: function openBox() {
		var _this2 = this;

		var h0 = this.wrapper.stop().height();
		var h1 = this.wrapper.css({ height: 'auto' }).height();

		this.wrapper.css({ height: h0 }).animate({ height: h1 }, 400, 'ioX2', function () {
			_this2.wrapper.css({ height: 'auto' });
		});
	},

	closeBox: function closeBox() {
		this.wrapper.stop().animate({ height: 0 }, 400, 'ioX2');
	}
});

},{}],8:[function(require,module,exports){
"use strict";

Canopus.tag('body', {

	created: function created() {
		var _this = this;

		this.type = null;

		this.computedStyle = window.getComputedStyle(this.el, '::before');

		this.check();

		Polaris.util.onResize(function (w, h) {
			_this.check();
		});
	},

	merged: function merged() {
		this.check(true);
	},

	check: function check() {
		var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


		var type = this.computedStyle.getPropertyValue('font-family');

		var isPC = type !== 'SP';

		if (force || type !== this.type) {

			this.type = type;

			this.notify('/breakpoint/isPC', isPC);
			this.notify('/breakpoint/type', type.toLowerCase());

			if (isPC) {
				this.notify('/breakpoint/pc', true);
			} else {
				this.notify('/breakpoint/sp', true);
			}
		}
	}
});

},{}],9:[function(require,module,exports){
"use strict";

Canopus.sel('.global-header .menu-button', {

	created: function created() {

		this.on('click', function (e) {
			e.preventDefault();
			$('html').toggleClass('show-global-nav');
		});
	}
});

},{}],10:[function(require,module,exports){
"use strict";

var defaultClassNames = function () {

	var classNames = {};

	for (var _key in Polaris.ua) {
		if (Polaris.ua[_key] && Polaris.util.isBoolean(Polaris.ua[_key])) {
			classNames['ua-' + _key] = 1;
		}
	}

	for (var key in Polaris.css) {
		if (key.indexOf('has') === 0) {
			if (Polaris.css[key]) {
				classNames[Polaris.util.camel2hyphen(key)] = 1;
			} else {
				classNames[Polaris.util.camel2hyphen(key.replace(/^has/, 'no'))] = 1;
			}
		} else if (key === 'transform') {
			for (var key2 in Polaris.css[key]) {
				if (Polaris.css[key][key2]) {
					classNames['has-' + key + '-' + key2] = 1;
				} else {
					classNames['no-' + key + '-' + key2] = 1;
				}
			}
		}
	}

	for (var key in Polaris.html) {
		if (key.indexOf('has') === 0) {
			if (Polaris.html[key]) {
				classNames[Polaris.util.camel2hyphen(key)] = 1;
			} else {
				classNames[Polaris.util.camel2hyphen(key.replace(/^has/, 'no'))] = 1;
			}
		}
	}

	for (var key in Polaris.event) {
		if (key.indexOf('has') === 0) {
			if (Polaris.event[key]) {
				classNames[Polaris.util.camel2hyphen(key)] = 1;
			} else {
				classNames[Polaris.util.camel2hyphen(key.replace(/^has/, 'no'))] = 1;
			}
		}
	}

	for (var key in Polaris.device) {
		if (key.indexOf('has') === 0) {
			if (Polaris.device[key]) {
				classNames[Polaris.util.camel2hyphen(key)] = 1;
			} else {
				classNames[Polaris.util.camel2hyphen(key.replace(/^has/, 'no'))] = 1;
			}
		}
	}

	classNames['device-pixel-ratio-' + Polaris.util.clamp(Math.ceil(Polaris.device.pixelRatio), 1, 3)] = 1;

	return Object.keys(classNames).join(' ');
}();

var globalClassNames = {};

Canopus.tag('html', {

	compiled: function compiled() {
		this.update();
	},

	created: function created() {
		var _this = this;

		this.subscribe('/htmlClasses/add', function (name) {
			globalClassNames[name] = 1;
			_this.update();
		});

		this.subscribe('/htmlClasses/remove', function (name) {
			delete globalClassNames[name];
			_this.update();
		});
	},

	update: function update() {
		var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		this.el.className = [defaultClassNames, Object.keys(globalClassNames).join(' ')].join(' ');
	}
});

},{}],11:[function(require,module,exports){
"use strict";

Canopus.tag('a', {

	compiled: function compiled() {
		var href = this.el.getAttribute('href');

		if (href && href.indexOf('#') === -1 && Polaris.util.parseURI(href).path === location.pathname && href.indexOf('http') === -1) {
			$(this.el).addClass('current');
		}
	},

	created: function created() {

		var $el = $(this.el);

		this.on('click', function () {
			if (!$el.attr('target') && !$el.hasClass('current')) {
				$el.addClass('clicked');
			}
		});
	}
});

},{}],12:[function(require,module,exports){
"use strict";

Canopus.sel('.logout', {

	created: function created() {

		this.on('click', function (e) {
			e.preventDefault();

			var fadeout = new Promise(function (resolve) {
				$('html').addClass('logout-clicked');
				setTimeout(resolve, 650);
			});

			var logout = new Promise(function (resolve) {
				jQuery.ajax({ url: '/account/logout' }).done(resolve);
			});

			Promise.all([fadeout, logout]).then(function () {
				Polaris.cookie.write('bijou-de-m-wishlist-id', '', { path: '/', expires: '10years' });
				Polaris.cookie.write('bijou-de-m-wishlist-count', 0, { path: '/', expires: '10years' });

				location.href = '/';
			});
		});
	}
});

},{}],13:[function(require,module,exports){
"use strict";

Canopus.sel('#modal', {

	created: function created() {
		var _this = this;

		this.normalContent = $('main, .global-header-content');

		this.observe('/modal/open', function (url) {
			_this.openModal(url);
		});

		this.observe('/modal/close', function () {
			_this.closeModal();
		});
	},

	openModal: function openModal(url) {

		this.normalContent.css({ paddingRight: this.calcScrollBarWidth() });

		$('html').addClass('show-modal');
	},

	closeModal: function closeModal() {
		var _this2 = this;

		$('html').addClass('hide-modal');

		setTimeout(function () {
			$('html').removeClass('show-modal');
			$('html').removeClass('hide-modal');
			_this2.normalContent.css({ paddingRight: '' });
		}, 400);
	},

	calcScrollBarWidth: function calcScrollBarWidth() {
		var $div = $('<div></div>').css({ width: 'calc(100vw - 100%)' });
		$('body').append($div);
		var width = $div.width();
		$div.remove();
		return width;
	}
});

Canopus.sel('#modal .modal-close', {

	created: function created() {
		var _this3 = this;

		this.on('click', function (e) {
			e.preventDefault();
			_this3.notify('/modal/close');
		});
	}
});

Canopus.sel('.open-modal-button', {

	created: function created() {
		var _this4 = this;

		this.on('click', function (e) {
			e.preventDefault();
			_this4.notify('/modal/open');
		});
	}
});

},{}],14:[function(require,module,exports){
"use strict";

var _config = require('../../core/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Canopus.sel('body', {

	created: function created() {
		var _this = this;

		this.customerID = this.attr['customer-id'];
		this.wishlistID = Polaris.cookie.read('bijou-de-m-wishlist-id', '');

		jQuery.ajax({
			url: _config2.default.API_URL + '/v1/customers/wishlist/get',
			type: 'POST',
			dataType: 'json',
			data: {
				customer_id: this.customerID,
				wishlist_id: this.wishlistID
			}
		}).done(function (json) {

			if (json.wishlist_id) {
				_this.notify('/wishlist/id', json.wishlist_id);
				Polaris.cookie.write('bijou-de-m-wishlist-id', json.wishlist_id, { path: '/', expires: '10years' });
			}

			_this.notify('/wishlist/products', json.products);
		});

		this.observe('/wishlist/products', function (products) {
			_this.notify('/wishlist/count', products.length);

			Polaris.cookie.write('bijou-de-m-wishlist-count', products.length, { path: '/', expires: '10years' });
		});

		var count = Polaris.cookie.read('bijou-de-m-wishlist-count', false);

		if (count !== false) {
			this.notify('/wishlist/count', count);
		}
	}
});

},{"../../core/config":23}],15:[function(require,module,exports){
"use strict";

Canopus.sel('.template-index', {

	created: function created() {
		var _this = this;

		this.observe('/loaded', function () {
			$(_this.el).find('.brand-select li').addClass('show');
		});
	}
});

},{}],16:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slide = require('../../util/slide');

var _slide2 = _interopRequireDefault(_slide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Canopus.sel('.template-product .product-gallery', {

	created: function created() {
		var _this = this;

		this.gallery = new Gallery(this.el);

		this.slide = new _slide2.default(this.el, {
			wrapper: '.product-gallery-image',
			mover: '.product-gallery-image ul',
			items: '.product-gallery-image li',
			index: '.product-gallery-thumbnails li',
			loop: true,
			duration: 600,
			easing: Polaris.easing.ioX2,
			resize: true
		});

		this.slide.on('before', function (arg) {
			$(_this.el).find('.product-gallery-thumbnails li').removeClass('current').eq(arg.next).addClass('current');
		});

		this.observe('/breakpoint/type', function (type) {
			if (type === 'pc') {
				_this.startGalleryPC();
			} else {
				_this.startGallerySP();
			}
		});
	},

	startGalleryPC: function startGalleryPC() {
		this.slide.unactivate();
		this.gallery.activate();
	},

	startGallerySP: function startGallerySP() {
		this.gallery.unactivate();
		this.slide.activate();
	}
});

var Gallery = function () {
	function Gallery(el) {
		var _this2 = this;

		_classCallCheck(this, Gallery);

		this.current = 0;
		this.active = false;
		this.thumbs = $(el).find('.product-gallery-thumbnails li');
		this.images = $(el).find('.product-gallery-image li');

		this.thumbs.on('click', function (e) {
			e.preventDefault();
			_this2.change(_this2.thumbs.index(e.currentTarget));
		});

		this.change(this.current);
	}

	_createClass(Gallery, [{
		key: 'activate',
		value: function activate() {
			this.active = true;
		}
	}, {
		key: 'unactivate',
		value: function unactivate() {
			this.active = false;
		}
	}, {
		key: 'change',
		value: function change(index) {
			var _this3 = this;

			this.current = index;
			this.images.removeClass('current').eq(index).addClass('current');
			this.thumbs.removeClass('current').eq(index).addClass('current');

			var next = this.images.removeClass('current').eq(index);

			var zIndex = 1 + this.images.toArray().reduce(function (zIndex, el) {
				return Math.max(el.style.zIndex, zIndex);
			}, 0);

			next.stop().css({ zIndex: zIndex, opacity: 0 }).animate({ opacity: 1 }, 300, 'iX2', function () {
				if (_this3.current === index) {
					_this3.images.css({ zIndex: 0, opacity: 0 }).eq(index).css({ zIndex: 1, opacity: 1 });
				}
			});

			this.images.eq(index).find('img').attr('src', this.images.eq(index).find('img').attr('data-src'));
		}
	}]);

	return Gallery;
}();

},{"../../util/slide":25}],17:[function(require,module,exports){
"use strict";

Canopus.sel('.template-product .product-gallery-image li', {

	created: function created() {
		var _this = this;

		this.image = $(this.el).find('img').get(0);

		this.isPC = false;

		this.observe('/breakpoint/type', function (type) {
			_this.isPC = type === 'pc';
		});

		Polaris.util.onResize(function () {
			_this.offset = $(_this.el).offset();
		});

		this.on('mousemove', function (e) {
			if (_this.isPC) {
				_this.move(e.clientX, e.clientY);
			}
		});

		this.on('touchstart', function (e) {
			$(_this.el).find('div').addClass('show');
		});

		this.on('touchmove', function (e) {
			if (_this.isPC) {
				e.preventDefault();
				_this.move(e.touches[0].clientX, e.touches[0].clientY);
			}
		});

		this.on('touchend', function (e) {
			if (_this.isPC) {
				$(_this.el).find('div').removeClass('show');
			}
		});
	},

	move: function move(x, y) {
		var imgW = this.image.clientWidth;
		var imgH = this.image.clientHeight;
		var boxW = this.el.clientWidth;
		var boxH = this.el.clientHeight;

		if (imgW > boxW + 10) {
			this.image.style.left = -1 * ((x - this.offset.left) / boxW) * (imgW - boxW) + 'px';
		} else {
			this.image.style.left = '';
		}

		if (imgH > boxH + 10) {
			this.image.style.top = -1 * ((y - this.offset.top) / boxH) * (imgH - boxH) + 'px';
		} else {
			this.image.style.top = '';
		}
	}
});

},{}],18:[function(require,module,exports){
"use strict";

Canopus.sel('#product-form', {

	created: function created() {
		var _this = this;

		var currentID = $(this.el).find('input[name=id]').val();

		this.variants = window.productVariants;

		this.current = this.variants.reduce(function (current, variant, i) {
			return variant.id == currentID ? variant : current;
		});

		this.on('change', '.options-selector select', function (e) {

			var currentOptions = $(_this.el).find('.options-selector select').toArray().map(function (el) {
				return el.value;
			});

			var index = _this.variants.reduce(function (index, variant, i) {

				var hit = currentOptions.reduce(function (hit, value, i) {
					return hit && variant['option' + (i + 1)] == value;
				}, true);

				return hit ? i : index;
			}, -1);

			if (index !== -1) {
				_this.updateVariant(_this.variants[index], true);
			}
		});

		this.on('change', '.quantity-selector select', function (e) {
			_this.updateVariant(_this.current);
		});

		this.updateVariant(this.current);
		this.updateOptions(this.current);
	},

	updateVariant: function updateVariant(variant) {
		var replaceQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		$(this.el).find('input[name=id]').val(variant.id);

		$(this.el).find('.product-price span').text(variant.price_c);

		if (variant.price > 0) {
			$(this.el).removeClass('no-price');
		} else {
			$(this.el).addClass('no-price');
		}

		if (variant.orderable) {
			$(this.el).removeClass('no-order');
		} else {
			$(this.el).addClass('no-order');
		}

		if (variant.quantity > 0 && variant.quantity >= $('#quantity').val()) {
			$(this.el).removeClass('no-quantity');
		} else {
			$(this.el).addClass('no-quantity');
		}

		if (replaceQuery) {

			this.updateOptions(variant);

			history.replaceState(null, null, location.pathname + '?variant=' + variant.id);
		}

		this.current = variant;

		this.notify('/variant/change', this.current.id);
	},

	updateOptions: function updateOptions(variant) {
		if (variant.price > 0) {
			if (variant.orderable) {
				$(this.el).find('#quantity').html(this.createQuantityOptions(9));
			} else {
				$(this.el).find('#quantity').html(this.createQuantityOptions(variant.quantity));
			}
		} else {
			$(this.el).find('#quantity').html(this.createQuantityOptions(0));
		}
	},

	createQuantityOptions: function createQuantityOptions(num) {
		if (num > 0) {
			return Polaris.util.sequence(1, num).reduce(function (text, num) {
				return text + ('<option value="' + num + '">' + num + '</option>');
			}, '');
		} else {
			return '<option value="0">-</option>';
		}
	}
});

},{}],19:[function(require,module,exports){
"use strict";

var _config = require('../../core/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Canopus.sel('.template-product .product-wish', {

	created: function created() {
		var _this = this;

		this.button = $(this.el);
		this.products = null;
		this.productID = window.productID;
		this.variantID = null;

		this.on('click', function (e) {
			e.preventDefault();

			if (_this.button.hasClass('processing')) return;

			_this.button.addClass('processing');

			var wishlistID = _this.fetch('/wishlist/id');

			if (wishlistID) {
				var action = _this.button.hasClass('wished') ? 'remove' : 'add';

				jQuery.ajax({
					url: _config2.default.API_URL + '/v1/customers/wishlist/' + action,
					type: 'POST',
					dataType: 'json',
					data: {
						wishlist_id: wishlistID,
						product_id: _this.productID,
						variant_id: _this.variantID
					}
				}).done(function (json) {
					_this.notify('/wishlist/count', json.products.length);
					_this.notify('/wishlist/products', json.products);
					_this.button.removeClass('processing');
				});
			}
		});

		this.observe('/variant/change', function (variantID) {
			_this.variantID = variantID;
			_this.update();
		});

		this.observe('/wishlist/products', function (products) {
			_this.products = products;
			_this.update();
		});
	},

	update: function update() {
		var _this2 = this;

		if (this.variantID !== null && this.products !== null) {

			var wished = this.products.reduce(function (hit, product) {
				return hit || product.id === _this2.productID && product.variant_id === _this2.variantID;
			}, false);

			if (wished) {
				this.button.addClass('wished');
			} else {
				this.button.removeClass('wished');
			}
		}
	}
});

},{"../../core/config":23}],20:[function(require,module,exports){
"use strict";

var _config = require('../../core/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Canopus.sel('.template-page-wishlist .wish-item', {

	created: function created() {
		var _this = this;

		this.on('click', '.wish-item-remove', function (e) {
			e.preventDefault();

			_this.remove().then(function (json) {
				_this.notify('/wishlist/count', json.products.length);
				_this.notify('/wishlist/products', json.products);
			});
		});

		this.on('click', '.add-cart', function (e) {
			e.preventDefault();

			$(_this.el).addClass('processing');

			jQuery.ajax({
				url: '/cart/add.js',
				type: 'POST',
				dataType: 'json',
				data: {
					wquantity: 1,
					id: _this.attr['vid']
				}
			}).done(function (json) {
				_this.remove().then(function () {
					location.reload();
				});
			});
		});
	},

	remove: function remove() {
		var _this2 = this;

		return new Promise(function (resolve) {
			jQuery.ajax({
				url: _config2.default.API_URL + '/v1/customers/wishlist/remove',
				type: 'POST',
				dataType: 'json',
				data: {
					wishlist_id: _this2.fetch('/wishlist/id'),
					product_id: _this2.attr['pid'],
					variant_id: _this2.attr['vid']
				}
			}).done(function (json) {
				resolve(json);
			});
		});
	}
});

},{"../../core/config":23}],21:[function(require,module,exports){
'use strict';

Canopus.sel('.template-page-wishlist', {
  created: function created() {
    var _this = this;

    this.observe('/wishlist/products', function (products) {
      products.forEach(function (product) {
        product.price = String(parseInt(product.price * 1.1)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      });

      _this.notify('wishitems', products);
    });
  }
});

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = new Canopus({

	auto: true,

	prefix: ['en'],

	bracket: ['<<', '>>'],

	unsafeBracket: ['<<<', '>>>']
});

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {

	API_URL: 'https://api.bijou-de-m.com'
};

},{}],24:[function(require,module,exports){
"use strict";

var _app = require('./core/app');

var _app2 = _interopRequireDefault(_app);

require('./components/global/html');

require('./components/global/breakpoint');

require('./components/global/link');

require('./components/global/header');

require('./components/global/wishlist');

require('./components/global/about-opener');

require('./components/global/logout');

require('./components/global/modal');

require('./components/index/title');

require('./components/collection/hero-view');

require('./components/collection/item-loader');

require('./components/product/gallery');

require('./components/product/scaler');

require('./components/product/variant');

require('./components/product/wish');

require('./components/account/login');

require('./components/account/address');

require('./components/contact/variant');

require('./components/wishlist/list');

require('./components/wishlist/item');

require('./components/cart/autoreload');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
	_app2.default.start();
});

$(window).on('load', function () {
	_app2.default.notify('/loaded');
});

},{"./components/account/address":1,"./components/account/login":2,"./components/cart/autoreload":3,"./components/collection/hero-view":4,"./components/collection/item-loader":5,"./components/contact/variant":6,"./components/global/about-opener":7,"./components/global/breakpoint":8,"./components/global/header":9,"./components/global/html":10,"./components/global/link":11,"./components/global/logout":12,"./components/global/modal":13,"./components/global/wishlist":14,"./components/index/title":15,"./components/product/gallery":16,"./components/product/scaler":17,"./components/product/variant":18,"./components/product/wish":19,"./components/wishlist/item":20,"./components/wishlist/list":21,"./core/app":22}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Slide = function () {
	function Slide(el, options) {
		var _this = this;

		_classCallCheck(this, Slide);

		this.el = el;

		this.options = jQuery.extend({
			wrapper: el,
			duration: 800,
			easing: Polaris.easing.ioX2,
			loop: true,
			next: null,
			prev: null,
			resize: true,
			flick: true,
			clones: 1
		}, options);

		this.$el = $(this.el);

		this.$wrapper = $(this.options.wrapper);

		this.$mover = this.$el.find(this.options.mover);

		this.$items = this.$el.find(this.options.items);

		this.slideNum = this.$items.length;

		this.active = true;

		this.itemW = 0;

		this.current = 0;

		this.frameID = null;

		this.moving = false;

		this.timer = null;

		this._moverX = 0;

		this.callbacks = {};

		if (this.option('loop')) {
			for (var i = 0; i < this.option('clones'); i++) {
				this.$mover.prepend(this.$items.eq(-i - 1).clone().addClass('__clone'));
				this.$mover.append(this.$items.eq(+i).clone().addClass('__clone'));
			}
			this.$clones = this.$mover.find('.__clone');
		}

		if (this.option('next')) {
			this.$el.on('click', this.option('next'), function (e) {
				if (_this.active) {
					e.preventDefault();
					_this.next();
				}
			});
		}

		if (this.option('prev')) {
			this.$el.on('click', this.option('prev'), function (e) {
				if (_this.active) {
					e.preventDefault();
					_this.prev();
				}
			});
		}

		if (this.option('index')) {
			this.$el.on('click', this.option('index'), function (e) {
				if (_this.active) {
					e.preventDefault();
					_this.change(_this.$el.find(_this.option('index')).index(e.currentTarget));
				}
			});
		}

		if (this.option('resize')) {
			this.resizeID = Polaris.util.onResize(function () {
				if (_this.active) _this.resize();
			});
		}

		var tx = null;
		var ty = null;
		var dx = null;
		var dy = null;
		var start = null;
		var flick = null;

		this.$mover.on('mousedown touchstart', function (e) {
			if (_this.active && _this.option('flick')) {
				Polaris.util.offFrame(_this.frameID);
				clearTimeout(_this.timer);

				tx = e.originalEvent.touches ? e.originalEvent.touches[0].clientX : e.clientX;
				ty = e.originalEvent.touches ? e.originalEvent.touches[0].clientY : e.clientY;
				dx = 0;
				dy = 0;
				flick = null;
				start = _this.moverX;
			}
		});

		this.$mover.on('mousemove touchmove', function (e) {
			if (_this.active && start !== null && flick !== false) {
				dx = (e.originalEvent.touches ? e.originalEvent.touches[0].clientX : e.clientX) - tx;
				dy = (e.originalEvent.touches ? e.originalEvent.touches[0].clientY : e.clientY) - ty;

				if (flick === null) {
					flick = Math.abs(dx) >= Math.abs(dy);

					if (flick) {
						e.preventDefault();
					} else {
						_this.change(_this.current);
						start = null;
					}
				} else {
					if (flick) {
						e.preventDefault();
						_this.moverX = start + dx;
					}
				}
			}
		});

		this.$mover.on('mouseleave mouseup touchend touchcancel', function (e) {
			if (_this.active && start !== null) {
				if (Math.abs(dx) > 50) {
					if (dx > 0) {
						_this.prev();
					} else {
						_this.next();
					}
				} else {
					_this.change(_this.current);
				}
				start = null;
			}
		});
	}

	_createClass(Slide, [{
		key: 'destroy',
		value: function destroy() {
			this.reset();
			this.$mover.off('*');
			Polaris.util.offResize(this.resizeID);
		}
	}, {
		key: 'merged',
		value: function merged() {
			this.reset();
			this.$mover.find('.__clone').remove();
			this.$items = this.$wrapper.find(this.options.items);
			this.$mover.prepend(this.$items.eq(-1).clone().addClass('__clone'));
			this.$mover.append(this.$items.eq(0).clone().addClass('__clone'));
			this.$clones = this.$mover.find('.__clone');
			this.slideNum = this.$items.length;
			this.updateIndex();
		}
	}, {
		key: 'option',
		value: function option(name) {
			if (name in this.options) {
				if (Polaris.util.isFunction(this.options[name])) {
					return this.options[name].call();
				} else {
					return this.options[name];
				}
			} else {
				return false;
			}
		}
	}, {
		key: 'resize',
		value: function resize() {
			this.itemW = this.$wrapper.outerWidth();

			this.$items.css({ width: this.itemW });

			if (this.option('loop')) {
				this.$clones.css({ width: this.itemW });
				this.$mover.css({ width: this.itemW * (this.slideNum + 2 * this.option('clones')), marginLeft: -this.itemW * this.option('clones') });
			} else {
				this.$mover.css({ width: this.itemW * this.slideNum });
			}

			this.change(this.current, true);
		}
	}, {
		key: 'reset',
		value: function reset() {
			Polaris.util.offFrame(this.frameID);
			clearTimeout(this.timer);
			this.current = 0;
		}
	}, {
		key: 'activate',
		value: function activate() {
			this.active = true;
			this.$clones.css({ display: '' });
			this.$items.css({ width: '' });
			this.$mover.css({ width: '', transform: '', margin: '' });
			this.resize();
		}
	}, {
		key: 'unactivate',
		value: function unactivate() {
			Polaris.util.offFrame(this.frameID);
			clearTimeout(this.timer);
			this.active = false;
			this.$clones.css({ display: 'none' });
			this.$items.css({ width: '' });
			this.$mover.css({ width: '', transform: '', margin: '' });
		}
	}, {
		key: 'pause',
		value: function pause() {
			Polaris.util.offFrame(this.frameID);
			clearTimeout(this.timer);
		}
	}, {
		key: 'resume',
		value: function resume() {
			var _this2 = this;

			if (this.option('interval')) {
				this.timer = setTimeout(function () {
					_this2.change(_this2.current + 1);
				}, this.option('interval'));
			}
		}
	}, {
		key: 'on',
		value: function on(type, callback) {
			if (type in this.callbacks) {
				this.callbacks[type].push(callback);
			} else {
				this.callbacks[type] = [callback];
			}
		}
	}, {
		key: 'change',
		value: function change(index) {
			var atOnce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


			if (this.active) {

				Polaris.util.offFrame(this.frameID);

				clearTimeout(this.timer);

				var x = -1 * this.itemW * index;

				this.current = index;

				if (atOnce) {
					this._animate(index, x, 0);
				} else {
					this._animate(index, x, this.option('duration'));
				}
			}
		}
	}, {
		key: 'next',
		value: function next() {
			this.change(this.current + 1, false);
		}
	}, {
		key: 'prev',
		value: function prev() {
			this.change(this.current - 1, false);
		}
	}, {
		key: '_animate',
		value: function _animate(rawIndex, x, duration, reason) {
			var _this3 = this;

			var x0 = this.moverX;
			var prev = this.current;
			var next = (this.slideNum + this.current % this.slideNum) % this.slideNum;

			this.moving = true;

			if (this.option('before')) {
				this.option('before')({ prev: prev, next: next, rawIndex: rawIndex });
			}

			if ('before' in this.callbacks) {
				this.callbacks['before'].forEach(function (callback) {
					callback({ prev: prev, next: next, rawIndex: rawIndex });
				});
			}

			this.updateIndex(next);

			this.frameID = Polaris.util.onFrame(function (ct, dt, pt) {

				var p = duration > 0 ? Math.min(Math.max(0, pt / duration), 1) : 1;

				_this3.moverX = x0 + (x - x0) * _this3.options.easing(p);

				if (p === 1) {

					_this3.moving = false;

					_this3.current = (_this3.slideNum + _this3.current % _this3.slideNum) % _this3.slideNum;

					_this3.moverX = -1 * _this3.itemW * _this3.current;

					if (_this3.option('after')) {
						_this3.option('after')({ prev: prev, next: next, current: _this3.current, rawIndex: rawIndex });
					}

					if ('after' in _this3.callbacks) {
						_this3.callbacks['after'].forEach(function (callback) {
							callback({ prev: prev, next: next, current: _this3.current, rawIndex: rawIndex });
						});
					}

					if (_this3.option('interval')) {
						_this3.timer = setTimeout(function () {
							_this3.change(_this3.current + 1);
						}, _this3.option('interval'));
					}

					return false;
				}
			});
		}
	}, {
		key: 'updateIndex',
		value: function updateIndex() {
			var _this4 = this;

			var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.current;

			if (this.option('index')) {
				setTimeout(function () {
					_this4.$wrapper.find(_this4.option('index')).removeClass('current').eq(index).addClass('current');
				});
			}
		}
	}, {
		key: 'moverX',
		set: function set(x) {
			this._moverX = x;

			var width = this.itemW * this.slideNum;

			this.$mover.css({ transform: 'translate3d(' + this._moverX % width + 'px, 0, 0)' });
		},
		get: function get() {
			return this._moverX;
		}
	}]);

	return Slide;
}();

exports.default = Slide;

},{}],26:[function(require,module,exports){
"use strict";

require('./app/main');

console.log('v1.1');

},{"./app/main":24}]},{},[26]);
